import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, X, Check } from 'lucide-react';

const STORAGE_KEY = 'cookie_consent';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Afișează bannerul dacă utilizatorul nu a ales încă
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) {
      // Mic delay pentru a nu apărea imediat la încărcarea paginii
      const t = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(STORAGE_KEY, 'declined');
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: 'easeOut' }}
          className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 sm:max-w-sm z-[70]"
          role="dialog"
          aria-label="Consimțământ cookie-uri"
        >
          <div className="bg-white dark:bg-[#242322] rounded-2xl shadow-2xl border border-[#E3DACB] dark:border-[#3D3A37] p-5">
            {/* Header */}
            <div className="flex items-start justify-between gap-3 mb-3">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-[#A67B5B]/10 flex items-center justify-center flex-shrink-0">
                  <Cookie size={16} className="text-[#A67B5B]" />
                </div>
                <h3 className="font-['Outfit'] font-semibold text-[#2C2A29] dark:text-[#F0EDE8] text-sm">
                  Folosim cookie-uri
                </h3>
              </div>
              <button
                onClick={decline}
                aria-label="Refuză și închide"
                className="w-6 h-6 flex items-center justify-center rounded-full hover:bg-[#F0EDE8] dark:hover:bg-[#3D3A37] text-[#6B6561] dark:text-[#9B9590] transition-colors flex-shrink-0 mt-0.5"
              >
                <X size={13} />
              </button>
            </div>

            {/* Text */}
            <p className="text-xs text-[#6B6561] dark:text-[#9B9590] leading-relaxed mb-4">
              Folosim cookie-uri pentru a îmbunătăți experiența pe site. Prin acceptare, ești de acord cu{' '}
              <span className="text-[#A67B5B] underline cursor-pointer">
                politica noastră de confidențialitate
              </span>.
            </p>

            {/* Butoane */}
            <div className="flex gap-2">
              <button
                onClick={decline}
                className="flex-1 py-2 px-3 text-xs font-medium rounded-lg border border-[#E3DACB] dark:border-[#3D3A37] text-[#6B6561] dark:text-[#9B9590] hover:bg-[#F9F6F0] dark:hover:bg-[#2E2C2A] transition-colors"
              >
                Refuz
              </button>
              <button
                onClick={accept}
                className="flex-1 py-2 px-3 text-xs font-medium rounded-lg bg-[#A67B5B] text-white hover:bg-[#8B654A] transition-colors flex items-center justify-center gap-1.5"
              >
                <Check size={12} />
                Accept
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

